import { render, staticRenderFns } from "./project-table.vue?vue&type=template&id=75fe1c84&scoped=true"
import script from "./project-table.vue?vue&type=script&lang=js"
export * from "./project-table.vue?vue&type=script&lang=js"
import style0 from "./project-table.vue?vue&type=style&index=0&id=75fe1c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fe1c84",
  null
  
)

export default component.exports